export default __webpack_public_path__ + "static/media/Care02.4a5c0a6a.png";